<template>
  <router-link
    :to="{ path: `/${resource}/${id}` }"
    target="_blank"
  >
    {{ text }}
  </router-link>
</template>

<script>
export default {
  props: ["resource", "id", "text"],
};
</script>